<template>
  <footer class="footer">
    <div class="container">
      <Logo />
      <div
        class="footer__date"
        v-html="getCopyright()"
      />
    </div>
  </footer>
</template>

<script>
  import Logo from '@/assets/svg/logo.svg'
  export default {
    name: 'Footer',

    components: { Logo },

    methods: {
      getCopyright () {
        return `&copy; ${new Date().getFullYear()} Mastercard`
      }
    }
    
  }
</script>

<style lang="scss">
.footer {
  margin-bottom: 49px;

  @include mobile {
    margin-bottom: 10px;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: $c-black;
    padding: 22px 46px 23px 31px;

    @include mobile {
      padding: 22px 16px;
    }
  }

  svg {
    width: 200px;
    height: 36px;

    @include mobile {
      width: 115px;
      height: 20px;
    }
  }

  &__date {
    color: $c-white;
    font-size: 18px;
    line-height: 1.2;

    @include mobile {
      font-size: 12px;
      line-height: 1;
    }
  }
}
</style>
